<template>
  <div class="page-content">
    <div class="content">
      <div class="month">
        <el-card class="card" :body-style='{height: "100%"}' shadow="hover">
          <month-calendar :yearData='yearData' @handleChangeYear='handleChangeYear'></month-calendar>
        </el-card>
      </div>
      <div class="calender">
        <el-card class="card" :body-style='{height: "100%"}' shadow="hover">
          <calender :monthData='monthData' @handleChange='handleChangeMonth'></calender>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import monthCalendar from './monthCalendar.vue'
import calender from './calendar.vue'
export default {
  components: {
    monthCalendar,
    calender
  },
  data() {
    return {
      yearData: [],
      monthData: [],
    }
  },
  created () {
    const currentYear = this.$moment(new Date()).startOf('year').format('YYYY/MM/DD')
    const currentMonth = this.$moment(new Date()).startOf('month').format('YYYY/MM/DD')
    this.handleChangeYear(currentYear)
    this.handleChangeMonth(currentMonth)
  },
  methods: {
    handleChangeYear (date) {
      this.$api.electricOperations.statisticPlanCountInYearForCommander(date).then((res) => {
        if (res.success) {
          this.yearData = res.data
        }
      })
    },
    handleChangeMonth (date) {
      console.log('currentMonth', date)
      this.$api.electricOperations.statisticPlanCountInMonthForCommander(date).then((res) => {
        if (res.success) {
          this.monthData = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  display: flex;
  text-align: left;
  color: #333;
}

.month {
  width: 600px;
  height: 100%;
  margin-right: 12px;
  .card {
    height: 100%;
  }
}

.calender {
  flex: 1;
  height: 100%;
  .card {
    height: 100%;
  }
}
</style>
